export default __webpack_public_path__ + "static/Home-1536-391cf8d18bd7745c906f146da3e8c19c.webp";